import { CaseSchema, SwitchStepSchema } from '@feedyou/schema'

import { UnsetDialogsService } from '../../../types'

export const unsetDialogs: UnsetDialogsService<SwitchStepSchema> = (dialogIds, step) => {
  let defaultCase
  let cases: CaseSchema[] = []

  if (step.default?.dialog) {
    defaultCase = dialogIds.includes(step.default.dialog)
      ? { ...step.default, dialog: undefined }
      : step.default
  }

  if (step.cases) {
    cases = step.cases.map((stepCase: CaseSchema) =>
      dialogIds.includes(stepCase.dialog as any) ? { ...stepCase, dialog: undefined } : stepCase
    )
  }

  return { ...step, default: defaultCase, cases }
}
